import PageHeader from 'components/general/pageHeader';
import React from 'react';
import { useSelector } from 'react-redux';
import './welcome.css';
import ToDo from './components/todo';
import Pathway from './components/pathway';
import Leaderboard from './components/leaderboard';
import Metrics from './components/metrics';
import Recommended from './components/recommended';
import { Course } from './components/course';

export const Welcome = ({ match }) => {
    const [multiColumn, setMultiColumn] = React.useState(true);
    const [profileId, setProfileId] = React.useState(null);
    const loaded = React.useRef(null);
    const { user } = useSelector(state => state.user);

    const useE4Points = true; // TODO - Get from settings

    const checkColumns = () => {
        if (loaded?.current) {
            const width = loaded.current.clientWidth;
            setMultiColumn(width > 800);
        }
    };

    React.useEffect(() => {
        setProfileId(match.params.id || user.id);
    }, [match.params.id, user.id]);

    React.useEffect(() => {
        window.addEventListener('resize', checkColumns);

        return () => {
            window.removeEventListener('resize', checkColumns);
        };
    }, []);

    React.useEffect(() => {
        if (loaded?.current) {
            checkColumns();
        }
    }, [loaded?.current]);

    const data = {
        pathway: {
            id: 1,
            name: 'Test Pathway Title',
            image: '/dist/img/sample-banner.png',
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl.',
            due: '2026-06-17',
            duration: 450,
            progress: 50,
        },
        pickup: {
            id: 1,
            name: 'Solution Selling Course',
            description:
                'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl.',
            image: '/dist/img/sample-banner.png',
            progress: 34,
        },
        toDo: [
            {
                type: 'review',
                due: '2025-12-17',
                name: 'Schedule Review',
                description: 'Please complete your scheduled review',
            },
            {
                type: 'objective',
                due: '2026-01-06',
                name: 'Complete an objective about something',
                duration: 120,
                description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl.',
            },
            {
                type: 'objective',
                due: '2026-02-13',
                name: 'Complete a learning objective?',
                duration: 170,
                description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl.',
            },
        ],
        recommended: [
            {
                id: 1,
                name: 'Solution Selling',
                flagged: true,
                image: '/dist/img/sample-banner.png',
                courseCount: 2,
                metricCount: 4,
                description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl.',
            },
            {
                id: 2,
                name: 'Answering the Phone Nicely',
                flagged: false,
                image: '/dist/img/sample-banner.png',
                courseCount: 1,
                metricCount: 0,
                description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.',
            },
            {
                id: 3,
                name: 'Engaging in C-Level Conversations',
                flagged: false,
                image: '/dist/img/sample-banner.png',
                courseCount: 0,
                metricCount: 2,
                description:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam euismod, nisl sit amet consectetur ultricies, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl, nunc nisl ultricies nunc, sit amet consectetur nisl nisl sit amet nisl. ',
            },
        ],
        metrics: [
            { id: 1, name: 'Win Rate', value: 0.951, format: 'P', change: -10 },
            { id: 2, name: 'New Pipeline Owned', value: 245250, format: 'M', change: 23 },
            { id: 3, name: 'Pipeline CLosed', value: 25600, format: 'M', change: -5 },
            { id: 4, name: 'New Opportunities Created', value: 15, format: 'C', change: 16 },
            { id: 5, name: 'Meetings Booked', value: 145, format: 'C', change: 45 },
            { id: 6, name: 'Deals Looked at', value: 0.156, format: 'P', change: -65 },
        ],
        leaderboard: [
            {
                id: 1,
                full_Name: 'John Doe',
                initials: 'JD',
                image: '',
                value: 100,
            },
            {
                id: 2,
                full_Name: 'James Ball',
                initials: 'JD',
                image: '',
                value: 91,
            },
            {
                id: 3,
                full_Name: 'Lindsay Shirley',
                initials: 'LS',
                image: '',
                value: 80,
            },
            {
                id: 4,
                full_Name: 'Sue Hornsey',
                initials: 'SH',
                image: '',
                value: 67,
            },
            {
                id: 5,
                full_Name: 'Matt Evans',
                initials: 'ME',
                image: '',
                value: 66,
            },
            {
                id: 6,
                full_Name: 'Duncan Elsworth',
                initials: 'DE',
                image: '',
                value: 55,
            },
            {
                id: 7,
                full_Name: 'Lee Chaundy',
                initials: 'LC',
                image: '',
                value: 54,
            },
            {
                id: 8,
                full_Name: 'Sarah Revel',
                initials: 'SR',
                image: '',
                value: 50,
            },
            {
                id: 9,
                full_Name: 'Faye Stanley',
                initials: 'FS',
                image: '',
                value: 40,
            },
            {
                id: 10,
                full_Name: 'Brian Warrington',
                initials: 'BW',
                image: '',
                value: 23,
            },
        ],
    };

    const displayPickup = !data.pathway && data.pickup;

    return (
        <div id="welcome-page" data-testid="welcome-page">
            <PageHeader title={`Welcome Back, ${user.first_Name}`} homepage />
            <section className="content mtm10" ref={loaded}>
                <div>
                    {data.pathway && <Pathway multiColumn={multiColumn} pathway={data.pathway} />}
                    {data.toDo?.length > 0 ? (
                        <div className={`mt30 ${displayPickup && multiColumn ? 'two-col-66' : ''}`}>
                            <div>
                                <ToDo multiColumn={multiColumn} profileId={profileId} data={data.toDo} />
                            </div>
                            {displayPickup && (
                                <div>
                                    <h2 className={`mb10 ${!multiColumn ? 'mt20' : ''}`}>Pick up where you left off</h2>
                                    <Course course={data.pickup} />
                                </div>
                            )}
                        </div>
                    ) : displayPickup ? (
                        <div className="mt30">
                            <h2 className="mb10">Pick up where you left off</h2>
                            <Course course={data.pickup} />
                        </div>
                    ) : null}
                    {data.recommended?.length > 0 && (
                        <div className="mt30">
                            <Recommended multiColumn={multiColumn} data={data.recommended} />
                        </div>
                    )}
                    {data.metrics.length > 0 && useE4Points && (
                        <div className={`${multiColumn ? 'two-col mt30' : ''}`}>
                            <div className={`${!multiColumn ? 'mt30' : ''}`}>
                                <Metrics data={data.metrics} />
                            </div>
                            <div className={`${!multiColumn ? 'mt30' : ''}`}>
                                <Leaderboard data={data.leaderboard} />
                            </div>
                        </div>
                    )}
                    {data.metrics.length > 0 && !useE4Points && (
                        <div className="mt30">
                            <Metrics data={data.metrics} />
                        </div>
                    )}
                    {data.metrics.length == 0 && useE4Points && (
                        <div className="mt30">
                            <Leaderboard data={data.leaderboard} />
                        </div>
                    )}
                </div>
            </section>
        </div>
    );
};

export default Welcome;
